module.exports = __webpack_public_path__ + "images/interview-Nielsen-2.svg";